import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { fetchApplication, submitApplication, approveApplication, rejectApplication, createOrgFromApp, requestDoc } from '/actions/applications';
import { toggleNotification } from '/actions/commonActions';
import { reduxForm, isDirty } from 'redux-form';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import CalculatorDialog from 'components/Loans/CalculatorDialog';
import heading from 'css/heading';
import LoanSchedule from './LoanSchedule';
import Header from 'components/Header';
import Divider from '@material-ui/core/Divider';
import _ from 'lodash';
import AlertDialog from 'components/AlertDialog';
import OnlineFormDetails from './OnlineFormDetails'
import { CheckboxAlertDialog } from '../FormComponents';
import Progress from './Progress';

const styles = theme => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  content: {
    maxWidth: '400px',
    margin: 'auto'
  },
  btnGroup: {
    display: 'flex',
    justifyContent: 'space-evenly'
  },
  success: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  cardView: {
    display: 'flex',
    justifyContent: 'center'
  },
  card: {
    minWidth: '500px',
    maxWidth: '800px',
  },
  listKey: {
    color: theme.palette.lightGrey,
    width: '120px',
    fontSize: '14px'
  }
});

class Show extends React.Component {
  componentDidMount = () => {
    const { match, dispatch } = this.props;
    dispatch(fetchApplication(this.props.appNumber));
  };

  handleCancel = () => {
    this.props.history.push('/applications');
  }

  handleSubmit = () => {
    this.props.dispatch(submitApplication(this.props.application.number));
  }

  handleApprove = () => {
    this.props.dispatch(approveApplication(this.props.application.number));
  }

  handleReject = () => {
    this.props.dispatch(rejectApplication(this.props.application.number));
  }

  renderSpinner = () => {
    if (this.props.showSpinner) {
      return (
        <CircularProgress color='primary' thickness={7} />
      );
    }
  }

  renderNotification = () => {
    if (this.props.notificationMsg) {
      return (
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={!!this.props.notificationMsg}
          onClose={()=>{this.props.dispatch(toggleNotification())}}
          message={<span id='message-id'>{this.props.notificationMsg}</span>}
        />
      );
    }
  }

  renderStatus = () => {
    const { application } = this.props
    return (
      <Typography variant='subheading' color='secondary' gutterBottom>
        <Progress key={application.number} application={application} />
      </Typography>
    );
  }

  createOrg = () => {
    this.props.dispatch(createOrgFromApp(this.props.application.number));
  }

  renderMessage = () => {
    if (this.props.dirty) {
      return (
        <Typography variant='subheading' color='secondary' gutterBottom>
          Application has been changed, please click on 'UPDATE' to save the change(s).
        </Typography>
      );
    }
  }

  renderSchedules = () => {
    if (this.props.application.status === 'updated' || this.props.dirty) return;
    return (
      <LoanSchedule quote={this.props.quote} schedules={this.props.schedules} />
    );
  }

  renderQuoteButton = () => {
    if (this.props.application && this.props.application.organisationId) {
      return (
        <CalculatorDialog
          buttonLabel='Quote'
          applicationNumber={this.props.application.number}
          disabled={this.props.dirty}
          organisationId={this.props.application.organisationId}
        />
      );
    } else {
      return (
        <CalculatorDialog
          buttonLabel='Quote'
          onClick={this.createOrg}
          applicationNumber={this.props.application.number}
          disabled={this.props.dirty}
          organisationId={this.props.organisation && this.props.organisation.id}
        />
      );
    }
  }

  approveBtn = () => {
    if (['quoted', 'doc_requested'].includes(this.props.application.status)) {
      return (
        <AlertDialog
          buttonLabel='Approve'
          variant='raised'
          color='secondary'
          confirmAction={this.handleApprove}
          title='You are about to approve the application, please confirm.'
          desc='Application will be waiting for Amazy admin to approve and contract will then be sent out to the applicant.'
        />
      );
    }
  }

  renderRejectButton = () => {
    return (
      <AlertDialog
        buttonLabel='Reject'
        color='secondary'
        confirmAction={this.handleReject}
        title='You are about to reject the application, please confirm.'
        desc='Rejection will obsolete the application, which cannot be undone.'
      />
    );
  }

  renderUpdateButton = () => {
    return (
      <Button variant='raised' color='primary' onClick={this.handleSubmit}>
        Update
      </Button>
    );
  }

  renderAlertNote = () => {
    if (this.props.application.sharedFolderUrl) {
      return (
        <div>
          <p>Note: Additional document(s) have been requested before for this application.</p>
          <p><a href={this.props.application.sharedFolderUrl} target='_blank'>View additional documents</a></p>
        </div>
      )
    }
  }

  renderRequestDocButton = () => {
    if (['quoted', 'doc_requested'].includes(this.props.application.status)) {
      const reqDocs = [
        {label: "Driver's licence", value: 'driver_licence'},
        {label: 'Last 3 months business bank statements', value: 'last_3_months_business_bank_statements'},
        {label: 'Last 2 quarters BAS', value: 'last_2_quarters_bas'},
        {label: 'Copy of ATO tax portal', value: 'copy_of_ato_tax_portal'},
        {label: 'Most recent financial statement', value: 'most_recent_financial_statement'}
      ];

      return (
        <CheckboxAlertDialog
          color='primary'
          buttonLabel='Request Doc'
          options={reqDocs}
          note={this.renderAlertNote()}
          submit={options=>{this.props.dispatch(requestDoc(this.props.application.number, options))}}
          title='Request Doc'
        />
      );
    }
  }

  renderButtons = () => {
    if (['approved', 'rejected'].includes(this.props.application.status)) {
      return null;
    }
    return (
      <div>
        <Header heading='Actions' />
        <br />
        <div style={heading.buttonGroup}>
          <Button onClick={this.handleCancel}>
            CANCEL
          </Button>
          { this.approveBtn() }
        </div>
        <br />
      </div>
    );
  }

  renderApplicationForm = () => {
    return (
      <div>
        <OnlineFormDetails application={this.props.application} />
      </div>
    );
  }

  render = () => {
    const { application } = this.props;
    if (!application) {
      return null;
    }
    return (
      <div className={this.props.classes.root}>
        <Typography variant='headline' gutterBottom>
          {`Application Number: ${application.number}`}
        </Typography>
        { this.renderStatus() }
        <Divider />
        <br />
        { this.renderApplicationForm() }
        { this.renderSchedules() }
        <br />
        { this.renderButtons() }
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  const appNumber = ownProps.match.params.appNumber;
  const application = state.applications && state.applications.application;
  const organisation = application && application.organisation;
  const quotes = application && application.quotes;
  const quote = quotes && _.first([...quotes]);
  const schedules = quote && quote.quoteSchedules;
  const dirty = state.form && state.form.applicationForm && state.form.applicationForm.dirty;

  return {
    initialValues: application && application.form,
    application,
    appNumber: ownProps.match.params.appNumber,
    notificationMsg: state.app.notificationMsg,
    showSpinner: state.app.showSpinner,
    organisation,
    quote,
    schedules,
    dirty,
  };
};

const reduxed = reduxForm({ form: 'applicationForm', enableReinitialize: true, dirty: isDirty('applicationForm') })(Show);
const connected = connect(mapStateToProps)(reduxed);
export default withStyles(styles)(connected);



// WEBPACK FOOTER //
// ./src/components/Applications/Show.js